import { useTranslation } from "react-i18next";
import { setAppLanguage } from "@/utils/language";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CheckIcon, LanguageIcon } from "@heroicons/react/24/outline";

const LANGUAGES = [
    {
        code: "en",
        name: "English",
        nativeName: "English",
        flag: "🇬🇧",
    },
    {
        code: "ar",
        name: "Arabic",
        nativeName: "العربية",
        flag: "🇸🇦",
    },
];

export function Header() {
    const { t, i18n } = useTranslation("login");

    const [isLanguageOpen, setIsLanguageOpen] = useState(false);
    const [mounted, setMounted] = useState(false);
    const languageDropdownRef = useRef(null);

    useEffect(() => {
        setMounted(true);
    }, []);

    const activeLanguage = mounted ? i18n.language : "en";

    const currentLanguage =
        LANGUAGES.find((language) => language.code === activeLanguage) ||
        LANGUAGES[0];
    const changeLanguage = async (languageCode) => {
        try {
            if (i18n.language === languageCode) {
                setIsLanguageOpen(false);
                return;
            }
            await setAppLanguage(languageCode);
            localStorage.setItem("app_language", languageCode);
            document.cookie = `NEXT_LOCALE=${languageCode}; path=/; max-age=31536000`;

            setIsLanguageOpen(false);
        } catch (error) {
            console.error("Language change failed:", error);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                languageDropdownRef.current &&
                !languageDropdownRef.current.contains(event.target)
            ) {
                setIsLanguageOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    return (

        <header className="w-full bg-[#F7F5F2] px-6 py-3 shadow-md flex justify-between items-center z-20">
            <div className="flex items-center gap-3">
                <img
                    src="/img/logos/logo.png"
                    alt="Corporate Supplier Logo"
                    className="w-[64px] h-[50px] object-contain"
                />
                <Link to="/" >
                <div className="flex flex-col leading-[100%]">
                    <span className="font-lato font-bold text-[22px] text-[#1A1918] mb-3">{t('brandName')}</span>
                </div>
                </Link>
            </div>
            <div
                ref={languageDropdownRef}
                className="relative flex items-center gap-3"
            >
                <Link to="/" className="flex items-center">
                    <LanguageIcon className="h-5 w-5" />
                </Link>

                <span className="hidden sm:inline">{t("language")}:</span>

                {/* Language Button */}
                <button
                    type="button"
                    onClick={() => setIsLanguageOpen(!isLanguageOpen)}
                    className="flex items-center gap-1 text-sm font-medium hover:text-green-900 transition"
                >
                    <span>{currentLanguage.flag}</span>
                    <span>{currentLanguage.nativeName}</span>
                    <span className="text-xs">▼</span>
                </button>

                {/* Language Dropdown */}
                {isLanguageOpen && (
                    <div
                        className="
                           absolute
                            top-full
                            right-0
                            mt-2
                            z-[100]
                            w-[190px]
                            rounded-lg
                            bg-white
                            shadow-lg
                            border
                            overflow-hidden
                            text-gray-800
                            "
                    >
                        <div className="px-3 py-2 border-b font-semibold text-sm">
                            {t("selectLanguage")}
                        </div>

                        {LANGUAGES.map((language) => (
                            <button
                                key={language.code}
                                type="button"
                                onClick={() => changeLanguage(language.code)}
                                className="
                                w-full
                                px-3
                                py-2
                                flex
                                items-center
                                justify-between
                                hover:bg-gray-100
                                transition
                                "
                            >
                                <div className="flex items-center gap-2">
                                    <span>{language.flag}</span>
                                    <span>{language.nativeName}</span>
                                </div>

                                {activeLanguage === language.code && (
                                    <CheckIcon className="h-4 w-4 text-green-600" />
                                )}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </header>
    )
}
export default Header;